/* ============
 * Send invoice
 * ============
 *
 * Send invoice to the FTP.
 */

import Vue from 'vue';

export default (id, ediOrderId) => (
  new Promise((resolve, reject) => {
    let url = `invoices/${id}/edi_order/${ediOrderId}/send`;

    if (localStorage.getItem('is_admin')) {
      url = `invoices/${id}/edi_order/${ediOrderId}/send?is_admin=true`;
    }

    Vue.$http.get(url)
    .then((response) => {
      resolve(response.data);
    })
    .catch(() => {
      reject();
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/invoice/sendEDI.js